// extracted by mini-css-extract-plugin
export default {"main":"MotoristsFranchising_main__4y1I9"};